function isLocal() {
	if (this.location.hostname.match(/^(localhost|127\.0\.0\.1|192\.168\.d+\.d+|100\.\d+\.\d+\.\d+)$/)) {
		return true;
	} else {
		return false;
	}
}

module.exports = {
	isLocal: isLocal(),
	TCGPartnerKey: 'MTGDeckAnalyzer',
	GoogleAnalyticsId: isLocal() ? 'G-FCQJ8NMTQ0' : 'G-PM64CP10W7'
};
